module.exports = __webpack_public_path__ + "static/back-card-desktop.c82b223a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/calendar/images/back-card-desktop.png
// module id = 589
// module chunks = 35783957827783